import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

const SIDEBAR_HUB_TASKS_QUERY_KEY = "onboarding:hub";
const STALE_TIME = 1000 * 10;

export default function useSidebarHubTasksQuery() {
    return useQuery({
        staleTime: STALE_TIME,
        retry: 2,
        queryKey: [SIDEBAR_HUB_TASKS_QUERY_KEY],
        queryFn() {
            return salesApiService.onboarding.fetchHubTasks();
        },
    });
}
